<mat-sidenav-container>
  <section class="container">
    @if (blockUi) {
      <div class="loading-image-container">
        <div class="loading-image small"></div>
        <div class="loading-text">Loading ...</div>
      </div>
    }
    <div class="header-wrapper">
      <p>
        <span class="headerText">{{ headerText }}</span>
      </p>
    </div>
    <div class="content-wrapper">
      <table class="mdl-data-table" data-qa-id="languages-table">
        <thead>
          <tr>
            <th>Language</th>
            <th style="text-align: center">Language Code</th>
            <th style="text-align: center">Culture Code</th>
            <th style="text-align: center">Enable Language</th>
            <th style="text-align: center">Enable Google Translate</th>
          </tr>
        </thead>
        <tbody>
          @for (language of languages; track language) {
            <tr>
              <td>{{ language.FriendlyName }}</td>
              <td style="text-align: center">{{ language.ISOLanguageCode }}</td>
              <td style="text-align: center">{{ language.LanguageCode }}</td>
              <td style="text-align: center">
                <mat-slide-toggle [disabled]="(language.LanguageCode | lowercase ) == 'en-gb'" [checked]="!language.MarkedAsDeleted" (change)="language.EnableGoogleTranslate = false; updateLanguageStatus(language.Id, language.MarkedAsDeleted = !language.MarkedAsDeleted)"></mat-slide-toggle>
              </td>
              <td style="text-align: center">
                <mat-slide-toggle [disabled]="language.MarkedAsDeleted || (language.LanguageCode | lowercase ) == 'en-gb'" [checked]="language.EnableGoogleTranslate" (change)="updateTranslateStatus(language.Id, language.EnableGoogleTranslate = !language.EnableGoogleTranslate)"></mat-slide-toggle>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </section>
</mat-sidenav-container>
